<div class="py-3 pb-0 box-white-rounded overflow-hidden">
  <div class="row">
    <div class="col-12">
      <div class="px-3">
        <div class="row align-items-center">
          <div class="col-6 text-start fs-18">
            <i class="{{ icon }} me-1"></i> {{ title }}
          </div>
          <div class="col-6 text-end">
            <ion-button
              size="small"
              shape="round"
              fill="outline"
              color="primary"
              (click)="goToSetting()"
              ><i class="fa-regular fa-cog"></i
            ></ion-button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="p-4">
        <ng-content>
          <div class="row h-100 justify-content-around">
            @for (button of buttons; track button; let index = $index) {
              <div class="col-auto text-center my-2">
                <div
                  class="control-item-container pointer-hover"
                  (click)="
                    clickOn(
                      button,
                      button.id !== undefined && button.id !== null
                        ? button.id
                        : index
                    )
                  "
                >
                  <div class="control-circle-outer">
                    <div
                      class="row h-100 align-items-center justify-content-center"
                    >
                      <div class="col text-center p-0">
                        <div class="control-circle-inner">
                          <div
                            class="row justify-content-center align-content-center"
                          >
                            <div class="col text-center p-0">
                              <i
                                class="{{ button.icon }} control-icon {{
                                  (button.id === undefined &&
                                    index === selectItem) ||
                                  (button.id !== undefined &&
                                    button.id === selectItem)
                                    ? button.color
                                    : 'color-medium'
                                }}"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pt-3">
                    <span class="fw-bold fs-14 text-uppercase">{{
                      button.title | translate
                    }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        </ng-content>
      </div>
    </div>

    @if (!disableBottom) {
      <div class="col-12 bg-background-secondary">
        <div class="px-3 py-2">
          <div class="row align-items-center" style="height: 30px">
            <div class="col-6 text-start">
              <span class="fw-bold {{ modeColor }}">{{ mode }}</span>
            </div>
            <div class="col-6 text-end">
              @if (statusMode === 'active') {
                <div class="d-inline-block status-default status-active">
                  {{ status | translate }}
                </div>
              } @else if (statusMode === 'inactive') {
                <div class="d-inline-block status-default status-inactive">
                  {{ status | translate }}
                </div>
              } @else if (statusMode === 'alarm') {
                <div
                  class="d-inline-block status-default status-alarm"
                  style="
                    border-radius: 30px;
                    background-color: white;
                    padding: 2px 10px;
                  "
                >
                  <i
                    class="fa-regular fa-triangle-exclamation color-warning"
                  ></i>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
